module.exports = __webpack_public_path__ + "img/spot-logo.3d6abb8c.png";